import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "CasinoGameGridWidget" */ './CasinoGameGridWidget'),
  modules: ['./CasinoGameGridWidget'],
  loading: () => <div />
});

export default LoadableWidget;
